import styled from 'styled-components';
import Button from '@wconcept/wconcept-ui-renewal/components/atoms/Button';
import { mixin } from '@wconcept/wconcept-ui-renewal/styles/index';

export const SortingBtn = styled(Button)`
  .text {
    font-size: 13px;
    line-height: 130%;
    color: #555;
  }

  .arrow {
    ${mixin.flex({})};
    width: 10px;
    height: 10px;
    margin-left: 1px;
  }

  @media ${({ theme }) => theme.media.smMax} {
    .text {
      font-size: ${mixin.pxToVw('13')};
    }

    .arrow {
      width: ${mixin.pxToVw('10')};
      height: ${mixin.pxToVw('10')};
      margin-left: ${mixin.pxToVw('1')};
    }
  }
`;
